/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE = 'ReadingsStore';

export const STATUS = {
	WRAPPER_INITIALIZED: 'WRAPPER_INITIALIZED',
	LOADING: 'LOADING',
	PROCESSING: 'PROCESSING',
	AVAILABLE: 'AVAILABLE'
};
